// extracted by mini-css-extract-plugin
module.exports = {"MidWrapperPart":"MidWrapperPart_MidWrapperPart__2UZVb"};